import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { SupportInfoDto } from '#models';

@Injectable({
  providedIn: 'root',
})
export class SupportApiService {
  private _http = inject(HttpClient);
  private readonly _baseUrl = environment.apiUrl;

  getSupportInfo(): Observable<SupportInfoDto> {
    return this._http.get<SupportInfoDto>(`${this._baseUrl}/support-info`);
  }
}
